/*
 * @FilePath     : /fe-eshotel/src/components/dialog/functional.js
 * @Author       : LiYang
 * @Date         : 2021-10-11 11:31:57
 * @LastEditTime : 2021-11-12 17:14:24
 * @LastEditors  : Please set LastEditors
 * @Description  : 
 */

import { isObject, isDef } from '@didi/es-mpx-shared'
let queue = [];

const conver = option =>  option = isObject(option) ? option : { message: option };

const Dialog = (option) => {
  option = conver(option);
  const pages = getCurrentPages();
  const context = pages[pages.length - 1];
  const dialog = context.selectComponent(option.selector || '#es-dialog');
  
  if (isDef(dialog)) {
    dialog.setOption({
      show: true,
      ...option
    });
    queue.push(dialog);
  }
}

Dialog.alert = (option) => {
  return Dialog({
    showCancelButton: false,
    ...conver(option),
  })
}

Dialog.confirm = (option) => {
  return Dialog({
    showCancelButton: true,
    ...conver(option),
  })
}

Dialog.close = () => {
  queue.forEach(dialog => dialog.close());
  queue = [];
}

export default Dialog;